// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"bdc18d40","334":"785d704c","567":"a7440ca4","586":"63ec2885","682":"785d704c","921":"04ffe39e","981":"04ffe39e"}[chunkId] + ".chunk.css";
};